// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"styles-m__tag-wrapper__1M7cb","tag-element":"styles-m__tag-element__3CYdo"};